export enum CookAllocationStatus {
    PARTIALLY_ALLOCATED = 'PARTIALLY_ALLOCATED',
    ALLOCATED = 'ALLOCATED',
    UNALLOCATED = 'UNALLOCATED'
}